import { useTranslation } from 'react-i18next'

import { HTTP_STATUS_NOT_FOUND } from '../../../constants/api'
import { APP_STATUS_ERROR } from '../../../constants/common'
import {
  USER_ITEM_SUPPORT_EMAIL,
  USER_MAIL_SUPPORT_LINK,
} from '../../../constants/user'
import { usePageBrowserTabTitle } from '../../../hooks'
import { isApiForbiddenStatus } from '../../../utils/api'
import { Link } from '../../Link'

import { ERROR } from './ErrorPage.constants'

import * as styles from './ErrorPage.module.css'

import ErrorPageIcon from '../../../icons/unique/error-page.svg'

function ErrorPage({ status }) {
  const { t } = useTranslation()

  // A forbidden section is presented as a missing one: the portal hides
  // what the viewer has no access to instead of explaining the 403.
  const preparedStatus = isApiForbiddenStatus(status)
    ? HTTP_STATUS_NOT_FOUND
    : status

  // Statuses come straight from API responses, so an unmapped one is possible.
  const error = ERROR[preparedStatus] ?? ERROR[APP_STATUS_ERROR]

  usePageBrowserTabTitle({
    errorStatus: preparedStatus,
  })

  return (
    <div className={styles.Error}>
      <ErrorPageIcon />
      <h1 className={styles.title}>{t(error.title)}</h1>
      <div className={styles.text}>
        <p>{t(error.text)}</p>
        <p>
          {t('ErrorPage.ReportTextKey')}{' '}
          <Link className={styles.link} to={USER_MAIL_SUPPORT_LINK}>
            {USER_ITEM_SUPPORT_EMAIL}
          </Link>
        </p>
      </div>
    </div>
  )
}

export default ErrorPage
